function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      var beforScrollTop = $(document).scrollTop()
      setTimeout(function () {
        if (beforScrollTop >= 62) {
          $('.time-part').addClass('stiky')
          $('.sp-header-top').addClass('stiky')
        } else {
          $('.time-part').removeClass('stiky')
          $('.sp-header-top').removeClass('stiky')
        }
      }, 50)
    })

    var swiper2 = new Swiper('.mySwiper3', {
      spaceBetween: 10,
      slidesPerView: 3,
      watchSlidesVisibility: true, //防止不可点击
      direction: 'vertical',
      on: {
        click: function () {
          var index = this.clickedIndex
          $('.mySwiper3 .swiper-slide').eq(index).addClass('swiper-slide-active').siblings().removeClass('swiper-slide-active');
          $('.top-product>img').attr('src', imgArr[index])
          if(index==0){
            $('#color>div')
            .eq(index)
            .addClass('active')
            .siblings()
            .removeClass('active')
            $('#Shape>div')
            .eq(index)
            .addClass('active')
            .siblings()
            .removeClass('active')
            changePrice(2)
          }else if(index==1){
            $('#color>div')
            .eq(1)
            .addClass('active')
            .siblings()
            .removeClass('active')
            $('#Shape>div')
            .eq(0)
            .addClass('active')
            .siblings()
            .removeClass('active')
            changePrice(4)
          }else if(index==2){
            $('#color>div')
            .eq(0)
            .addClass('active')
            .siblings()
            .removeClass('active')
            $('#Shape>div')
            .eq(1)
            .addClass('active')
            .siblings()
            .removeClass('active')
            changePrice(1)
          }else if(index==3){
            $('#color>div')
            .eq(1)
            .addClass('active')
            .siblings()
            .removeClass('active')
            $('#Shape>div')
            .eq(1)
            .addClass('active')
            .siblings()
            .removeClass('active')
            changePrice(3)
          }
          
        },
      },
    })
    // var swiper3 = new Swiper('.mySwiper4', {
    //   thumbs: {
    //     swiper: swiper2,
    //   },
    //   effect: 'fade',
    //   fadeEffect: {
    //     crossFade: true,
    //   },
    //   on: {
    //     slideChange: function () {
    //       var index = this.activeIndex
    //       $('#color .option')
    //         .eq(index)
    //         .addClass('active')
    //         .siblings()
    //         .removeClass('active')
    //     },
    //   },
    // })
    var imgArr = [
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20241018-pro-1.png',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20241018-pro-2.png',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20241018-pro-3.png',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20241018-pro-4.png',
    ]
    let prods = window.product
    let variants = prods[0]
  function getCur(){
    let color = $('#color div.active').attr('data-val')
    let size = $('#sp-size div.active').attr('data-val')
    return prods.filter(item=> item.option1 == color)[0]
  }
  function changePrice(t){
    let num = $('#calcNumber').val()
    if(t){
      variants = prods[t-1]
    }
    let price = (variants.price * num / 100).toFixed(2)
    let compare = (variants.compare_at_price * num  / 100).toFixed(2)
    // if(num == 1){
    //   price = (getCur().price * num / 100).toFixed(2)
    // }else if(num == 2){
    //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
    // }else if(num == 3){
    //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
    // }else {
    //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
    // }
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $('.price1 #new').html(price)
    $('.price2 #old').html(compare)
    let off_font = 100 - Math.ceil(variants.price / variants.compare_at_price * 100)
    $(".product-part .sp-pro-offs #num").html(off_font);
  }
  $('.sp-btn-style').click(function(){
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + variants.id + ':' + num
  })
  if(window.cartCount > 0){
    $("#cardNum").removeClass("gray");
  }
    //加减
    
    $(".reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
      changePrice()
    }
  });
  $(".add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice()
  });



    // style选项
    let typeOptions = $('#Shape .option')
    let typeOptions2 = $('#color .option')
    $('.opt-group .option').click(function () {
      $(this).addClass('active').siblings().removeClass('active')
    })
    typeOptions.click(function () {
      changeOption()
    })
    typeOptions2.click(function () {
      changeOption()
    })
    // // 切换选项
    function changeOption() {
      var index = $('#Shape .option.active').index()
      var index2 = $('#color .option.active').index()
      if (index == 0 && index2 == 0) {
        swiper2.slideTo(0, 1000, false)

        // $('.mySwiper3 .swiper-slide').eq(0).trigger('click');

        console.log($('.mySwiper3 .swiper-slide').eq(0))
        $('.mySwiper3 .swiper-slide').eq(0).addClass('swiper-slide-active').siblings().removeClass('swiper-slide-active');
        $('.top-product>img').attr('src', imgArr[0])
        $('.top-product>span').hide()
        $('.sp-pro-text').show()
        changePrice(2)
      } else if (index == 0 && index2 == 1) {
        swiper2.slideTo(1, 1000, false)
        $('.mySwiper3 .swiper-slide').eq(1).addClass('swiper-slide-active').siblings().removeClass('swiper-slide-active');
        // console.log($('.mySwiper3 .swiper-slide').eq(1))
        // $('.mySwiper3 .swiper-slide').eq(1).trigger('click')
        $('.top-product>img').attr('src', imgArr[1])
        $('.top-product>span').hide()
        $('.sp-pro-text2').show()
        changePrice(4)
      } else if (index == 1 && index2 == 0) {
        swiper2.slideTo(2, 1000, false)
        // console.log($('.mySwiper3 .swiper-slide').eq(2))
        // $('.mySwiper3 .swiper-slide').eq(2).trigger('click')
        $('.mySwiper3 .swiper-slide').eq(2).addClass('swiper-slide-active').siblings().removeClass('swiper-slide-active');
        $('.top-product>img').attr('src', imgArr[2])
        $('.top-product>span').hide()
        $('.sp-pro-text').show()
        changePrice(1)
      } else if (index == 1 && index2 == 1) {
        swiper2.slideTo(3, 1000, false)
        // console.log($('.mySwiper3 .swiper-slide').eq(3))
        // $('.mySwiper3 .swiper-slide').eq(3).trigger('click')
        $('.mySwiper3 .swiper-slide').eq(3).addClass('swiper-slide-active').siblings().removeClass('swiper-slide-active');
        $('.top-product>img').attr('src', imgArr[3])
        $('.top-product>span').hide()
        $('.sp-pro-text2').show()
        changePrice(3)
      }
    }
    

    $(".product-part .cart-btn").click(function () {
      var data = {
        id: variants.id,
        quantity: $('#calcNumber').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $("#cardNum").html(result.item_count);
            $("#cardNum").removeClass("gray");
          });
        },
        dataType: "json",
      });

      var img = $('.top-product img')
      var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.sp-part5').append(flyer)
      flyer.classList.add("sp_clone");

      $(".product-part").append(flyer);
      $(".sp_clone").css({
        width: img[0].width,
        height: img[0].height,
        position: "fixed",
        top: img[0].offsetTop,
        left: img.offset().left,
        "z-index": "99",
      });
      $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
      let finish = $(".sp-cart");
      $(".sp_clone").animate(
        {
          top: finish[0].offsetTop + $(".time-part").height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        "linear",
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach();
            }
          );
        }
      );
    });
    // addCart()
    function addCart() {
      // 加入购物车
      $('.addCerts').click(function () {
        // do something here
        var number =
          Number($('.sp-cart #cardNum').html()) + Number($('#calcNumber').val())
        $('.sp-cart #cardNum').html(number)


        var data = {
        id: variants.id,
        quantity: $('#calcNumber').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $("#cardNum").html(result.item_count);
            $("#cardNum").removeClass("gray");
          });
        },
        dataType: "json",
      });
        var img = $('.top-product img')
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.sp-part5').append(flyer)
        $('.clone').css({
          width: '932px',
          height: '932px',
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop + 350,
            left: finish[0].offsetLeft + finish.width() / 2 - 50,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop =
          targetElement.offsetTop -
          $('.time-part').height() -
          $('.sp-header-top').height()
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
